import { Components, Theme } from '@mui/material';

const muiCircularProgress: Components<Theme>['MuiCircularProgress'] = {
	styleOverrides: {
		colorPrimary: ({ theme }) => ({
			color: theme.palette.white,
		}),
	},
};

export default muiCircularProgress;
